module.exports = __webpack_public_path__ + "static/media/1_en.84893d77.png";